/** Respaldo del borrador en este dispositivo (por si se cae la red). Siempre con try/catch: puede no haber storage. */
import type { ModelInputs } from "@/engine/types";

export interface BorradorLocal { inputs: ModelInputs; updatedAt: string; source: string; seedSnapshotId: string | null }
const clave = (memberId: string) => `wn.borrador.${memberId}`;

export function leerLocal(memberId: string): BorradorLocal | null {
  try { const t = localStorage.getItem(clave(memberId)); return t ? (JSON.parse(t) as BorradorLocal) : null; } catch { return null; }
}
export function escribirLocal(memberId: string, b: BorradorLocal) {
  try { localStorage.setItem(clave(memberId), JSON.stringify(b)); } catch { /* sin storage: solo servidor */ }
}
export function borrarLocal(memberId: string) {
  try { localStorage.removeItem(clave(memberId)); } catch { /* nada */ }
}
